// @flow
export const SHOT_ACTIONS = {
  KIWI: "KIWI",
  PAX: "PAX",
  AERO: "AERO",
  CS: "CS",
  INFO: "INFO",
  REPAIR: "REPAIR",
  WAIT: "WAIT",
}

export const SHOT_CONDITIONS = {
  WAIT: "wait",
  MINOR_DELAY: "minorDelay",
  ITINERARY_UPDATED: "itineraryUpdated",
  NON_GUARANTEE: "nonGuarantee",
  OFFERS: "offers",
  OFFERS_WITHOUT_ACCOMMODATION: "offersWithoutAccommodation",
  EXPIRED_WITH_ALTERNATIVES: "expiredWithAlternatives",
  EXPIRED_WITH_NO_ALTERNATIVES: "expiredWithNoAlternatives",
  CONTACT_US: "contactUs",
  SEARCHING: "searching",
  EXPIRED_EMERGENCY: "expiredEmergency",
}

export const ALTERNATIVE_VIEWS_TKEYS = [
  __("schedule_changes.pick_solution"), // not shown
  __("schedule_changes.select_alternative"),
  __("common.summary"),
]

export const MODAL_OPEN_STATUSES = {
  CLOSED: "CLOSED",
  CLOSING: "CLOSING",
  OPEN: "OPEN",
}

export const SINGLE_COLUMN_WIDTH = 950

export const SCHEDULE_CHANGES_WIDTH = 1280

export const CLOSING_ANIMATION_DURATION = 250

// status expected by BE
export const ALTERNATIVE_STATUSES = {
  ACKNOWLEDGED: "acknowledged",
  SELECTED: "selected",
  REFUNDED: "refunded",
}

export const ERRORS = {
  NO_SUCH_FLIGHT: "no such flight",
}
